import { IProvider } from '../../types/promosPage';
import { IApplicationState } from '../../types/redux';

export const selectPromoCompilationProviders = (state: IApplicationState): IProvider[] => {
  const {
    promosPage: {
      topPromos: { providers },
    },
  } = state;

  return providers;
};
